"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFieldTemplates = void 0;
var CardTypeName_1 = require("../../types/enums/CardTypeName");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
/**
 * Replaces field templates, e.g. {{field::Front}}, in the card templates,
 * and returns the raw content that should be used for the front and back
 * of a card.
 *
 * @param cardType Contains front and back card templates.
 * @param fields The fields used for field template replacement.
 */
function replaceFieldTemplates(cardType, fields) {
    (0, tiny_invariant_1.default)(cardType.name !== CardTypeName_1.CardTypeName.Cloze, "This function does not support Cloze cards");
    var reducer = function (acc, currVal) {
        return acc.replace(new RegExp("{{field::".concat(currVal.name, "}}"), "g"), currVal.value);
    };
    var back = fields.reduce(reducer, cardType.backTemplate);
    var front = fields.reduce(reducer, cardType.frontTemplate);
    return {
        back: back,
        front: front,
    };
}
exports.replaceFieldTemplates = replaceFieldTemplates;
